/**
 * Note: response from backend does not have yet the same names as FormAddressInterface which is a potential...
 * REFACTOR address column names so there is no need from AddressInterface -> FormAddressInterface
 *
 * @param a address response from backend
 */
export function from(a) {
    var _a;
    return {
        city: a.city,
        code: a.zip_code,
        country: a.country,
        name: (_a = a.company_name) !== null && _a !== void 0 ? _a : null,
        street: a.street
    };
}
